import React, { useState, useEffect, useRef } from 'react'
import { Button, Input, Affix, message, Modal, Divider } from 'antd'
import InfiniteScroll from 'react-infinite-scroller';
import { searchCollList, tagInfo, updateTagInfo } from "../../../api/inspiration";
import CollItem from './components/CollItem'
import TagsDrawer from './components/TagsDrawer'
import CheckModal from './CheckModal';
import './index.less'

const { confirm } = Modal

export default () => {
  const reload = useRef(false)
  const [word, setWord] = useState('客厅')
  const [ids, setIds] = useState('')
  const [collUrl, setCollUrl] = useState('')
  const [canShield, setCanShield] = useState(false)
  const [onSearchIds, setOnSearchIds] = useState(false)
  const [state, setState] = useState({
    fetching: false,
    page: 1,
    count: 1,
    hasMore: true,
    list: [],
  });
  // 编辑标签抽屉
  const [editTagsDrawer, setEditTagsDrawer] = useState(false)
  // collId
  const [collId, setCollId] = useState(null)
  // 分类标签
  const [classifyTags, setClassifyTags] = useState([])
  // 属性标签
  const [attrTags, setAttrTags] = useState([])
  // 补充标签
  const [supplementTags, setSupplementTags] = useState([])
  // 图集名称
  const [collName, setCollName] = useState('')
  const [checkModalVisible, setCheckModalVisible] = useState(false)

  useEffect(() => {
    if (reload) {
      reload.current = false
      loadFunc()
    }
  }, [reload.current])
  useEffect(() => {
    if (!checkModalVisible) {
      setCollId(null)
    }
  }, [checkModalVisible])

  const loadFunc = async () => {
    const { page, list, count, hasMore, fetching } = state;
    if (!hasMore || fetching) return;
    setState({
      ...state,
      fetching: true,
    });
    const res = await searchCollList(ids ? { collId: ids } : collUrl ? { collUrl } : {
      page: page,
      pageSize: 48,
      searchWord: word
    })

    setState({
      ...state,
      page: state.page + 1,
      fetching: false,
      hasMore: Boolean(res.data?.count >= 48),
      list: [...list, ...(res?.data?.collections ?? [])],
    });
    setCanShield(res?.data?.isSensitive)
    if (ids) {
      setCanShield(true)
    }
  };

  const handleInputChange = (e) => {
    setWord(e.target.value)
  }

  const handleIdsChange = (e) => {
    setIds(e.target.value)
  }
  const handleCollUrlChange = (e) => {
    setCollUrl(e.target.value)
  }

  const clearAll = () => {
    setWord('');
    setIds('');
    setCollUrl('')
    setState({
      fetching: false,
      page: 1,
      count: 1,
      hasMore: true,
      list: [],
    });
  };

  const onSearch = () => {
    if (!word && !ids && !collUrl) {
      message.info('请输入搜索词或id或URL')
      return
    }
    setState({
      fetching: false,
      page: 1,
      count: 1,
      hasMore: true,
      list: [],
    })
    setOnSearchIds(ids.length)
    reload.current = true
  }

  // 打开标签编辑抽屉
  const showDrawer = () => {
    setEditTagsDrawer(true);
  };

  // 关闭标签编辑抽屉
  const onClose = () => {
    setEditTagsDrawer(false);
    setCollId(null)
    setCollName('')
    setAttrTags([])
    setClassifyTags([])
    setSupplementTags([])
  };

  // 搜索图集侧边栏
  const getTagInfo = async (collId) => {
    const res = await tagInfo(collId)
    if (res?.error?.code == 0 && res?.data) {
      setCollId(res.data.collId)
      setCollName(res.data.collName)
      setAttrTags(res.data.attrTags)
      setClassifyTags(res.data.classifyTags)
      setSupplementTags(res.data.supplementTags)
    }
  }

  // 搜索图集侧边栏更新
  const goUpdateTagInfo = async () => {
    const updateData = { attrTags, classifyTags, collId, collName, supplementTags }
    const res = await updateTagInfo(updateData)
    if (res?.error?.code == 0) {
      message.success('修改成功')
      onClose()
    } else if (res.error.code == 1) {
      message.error(res.error.message)
    } else {
      message.error('修改失败')
    }
  }

  const onCheckModelCancel = () => {
    setCheckModalVisible(false)
  }
  const onCheckModelOk = () => {
    setCheckModalVisible(false)
  }

  return (
    <div className='imgQuality'>
      <div className='imgQualityHeader'>图集管理&gt;图集列表</div>
      <Affix>
        <div className='imgQualityOperation'>
          <div className='top-recommend-searchArea' style={{ display: 'inline-block', width: 300 }}>
            搜索词：
            <Input
              style={{ width: 200 }}
              placeholder='请输入内容'
              value={word}
              onChange={handleInputChange}
              onPressEnter={onSearch}
            />
          </div>
          <div style={{ display: 'inline-block', width: 300 }}>
            图集ID：
            <Input
              style={{ width: 200 }}
              placeholder='请输入内容'
              value={ids}
              onChange={handleIdsChange}
              onPressEnter={onSearch}
            />
          </div>
          <div style={{ display: 'inline-block', width: 500 }}>
            图集URL：
            <Input
              style={{ width: 350 }}
              placeholder='请输入图集URL'
              value={collUrl}
              onChange={handleCollUrlChange}
              onPressEnter={onSearch}
            />
          </div>
          <div style={{ display: 'inline-block', width: 100 }}>
            <Button type='danger' onClick={clearAll}>清空</Button>
          </div>
          <div style={{ display: 'inline-block', width: 100 }}>
            <Button type="primary" onClick={onSearch}>查询</Button>
          </div>
          <Divider />
        </div>
      </Affix>
      <div style={{ width: 1660 }}>
        <InfiniteScroll
          className="infiniteScroll"
          pageStart={0}
          loadMore={loadFunc}
          hasMore={state.hasMore}
          initialLoad={true}
        >
          {state.list?.map((v, i) => (
            <CollItem getTagInfo={getTagInfo} showDrawer={showDrawer} key={i} index={i} data={v} collId={collId} setCollId={setCollId} setCheckModalVisible={setCheckModalVisible} />
          ))}
        </InfiniteScroll>
        {!state.list.length ? <div className="imgQualityEmpty">没有搜索结果哦 🔍</div> : null}
      </div>
      < TagsDrawer editTagsDrawer={editTagsDrawer} onClose={onClose} attrTags={attrTags} classifyTags={classifyTags} supplementTags={supplementTags} setClassifyTags={setClassifyTags} setSupplementTags={setSupplementTags} setAttrTags={setAttrTags} collId={collId} collName={collName} setCollName={setCollName} goUpdateTagInfo={goUpdateTagInfo}></TagsDrawer>
      <CheckModal modalVisible={checkModalVisible} onCancel={onCheckModelCancel} onOk={onCheckModelOk} collId={collId}
      />
    </div >
  )
}